import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

const YesIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <g clipPath="url(#clip0_433_7306)">
                <path
                    d="M12.3125 21.418C17.2831 21.418 21.3125 17.3885 21.3125 12.418C21.3125 7.44741 17.2831 3.41797 12.3125 3.41797C7.34194 3.41797 3.3125 7.44741 3.3125 12.418C3.3125 17.3885 7.34194 21.418 12.3125 21.418Z"
                    fill="#19DA38"
                />
                <path d="M8.5625 13.168L10.8125 15.418L16.0625 10.168" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_433_7306">
                    <rect width="24" height="24" fill="white" transform="translate(0.3125 0.417969)" />
                </clipPath>
            </defs>
        </svg>
    );
};

const NoIcon = () => {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_332_26884)">
                <path
                    d="M12.5625 21.418C17.5331 21.418 21.5625 17.3885 21.5625 12.418C21.5625 7.44741 17.5331 3.41797 12.5625 3.41797C7.59194 3.41797 3.5625 7.44741 3.5625 12.418C3.5625 17.3885 7.59194 21.418 12.5625 21.418Z"
                    fill="#FC695C"
                />
                <path d="M9.28516 9.5918L15.9396 16.2463" stroke="white" strokeWidth="1.33089" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.28516 16.2463L15.9396 9.5918" stroke="white" strokeWidth="1.33089" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_332_26884">
                    <rect width="24" height="24" fill="white" transform="translate(0.5625 0.417969)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default function SectionA4() {
    const { t } = useLang('delta_pro_ultra.launch.detail.SectionA4');

    const tableData = {
        headers: [
            {
                name: t('item1_name'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1750233257736/img1.png',
            },
            {
                name: t('item2_name'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1750233257575/img2.png',
            },
            {
                name: t('item3_name'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1750233257409/img3.png',
            },
            {
                name: t('item4_name'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1750233257911/img4.png',
            },
            {
                name: t('item5_name'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1750233258111/img5.png',
            },
            {
                name: t('item6_name'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1750233258526/img6.png',
            },
            {
                name: t('item7_name'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1750822385301/img7.png',
            },
        ],
        rows: [
            {
                title: t('label2'),
                cells: [t('item1_statue'), t('item2_statue'), t('item3_statue'), t('item4_statue'), t('item5_statue'), t('item6_statue'), t('item7_statue')],
            },
            {
                title: t('label3'),
                cells: [t('item1_tag'), t('item2_tag'), t('item3_tag'), t('item4_tag'), t('item5_tag'), t('item6_tag'), t('item7_tag')],
            },
            {
                title: t('label4'),
                cells: [t('item1_desc'), t('item2_desc'), t('item3_desc'), t('item4_desc'), t('item5_desc'), t('item6_desc'), t('item7_desc')],
            },
        ],
    };

    return (
        <div className={`page-sectionA4 ${styles.SectionA4}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />

            <div className={`eco-content ${styles.SectionA4}`}>
                <div className="compatibility-table">
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                {tableData.headers.map((header, index) => (
                                    <th key={index}>
                                        <img className="header-img" src={header.img} alt="" />
                                        <div className="header-name">{header.name}</div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td>{row.title}</td>
                                    {row.cells.map((cell, cellIndex) =>
                                        rowIndex === 0 ? (
                                            <td key={cellIndex}>
                                                <div className="icon">{['YES', 'JA', 'OUI', 'SÌ', 'SÍ'].includes(cell) ? <YesIcon /> : <NoIcon />}</div>
                                            </td>
                                        ) : (
                                            <td key={cellIndex}>{cell}</td>
                                        ),
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
